var map = {
	"./cykairos.png": 1069,
	"./empty.png": 1070,
	"./espy.png": 1071,
	"./irbis.png": 1072,
	"./krystal.png": 1073,
	"./krystal1.png": 1074,
	"./logo.png": 1075,
	"./sherlock.png": 1076,
	"./snip.png": 1077,
	"./tkmt.png": 1078,
	"./unicorn1.png": 1079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1068;